import { QueryClient, type DefaultOptions } from "@tanstack/react-query"

export const QUERY_STALE_TIME_MS = 60 * 1000
export const QUERY_GC_TIME_MS = 10 * 60 * 1000

export function getDefaultQueryRetryDelay(attemptIndex: number) {
  const baseDelay = Math.min(1000 * 2 ** attemptIndex, 30_000)
  const jitter = Math.random() * 100

  return baseDelay + jitter
}

export const defaultQueryOptions = {
  staleTime: QUERY_STALE_TIME_MS,
  gcTime: QUERY_GC_TIME_MS,
  refetchOnWindowFocus: false,
  retry: 3,
  retryDelay: getDefaultQueryRetryDelay,
} satisfies NonNullable<DefaultOptions["queries"]>

export const defaultMutationOptions = {
  retry: false,
} satisfies NonNullable<DefaultOptions["mutations"]>

export const queryClientDefaultOptions = {
  queries: defaultQueryOptions,
  mutations: defaultMutationOptions,
} satisfies DefaultOptions

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: queryClientDefaultOptions,
  })
}
